import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
}

export function FollowOnlyErrorToast(props: Props) {
  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="error"
      body={polyglot.t("toasts.edit_is_follow_only_error.body")}
      id={props.id}
    />
  )
}
